import { GetScore, Lifter, Meet } from "types";
import { toKg } from "util/conversions";
import { getTotal } from "util/lifterHelper";
import { isLbsMeet } from "util/meetHelper";
import { ageCoef } from "./age";

// ABS Points polynomial coefficients
const params = {
  MALE: [
    -302.73685723159986, 23.05383370608118, -0.1658348960705138,
    0.0005247429600101219, -5.54828561195429e-7,
  ],
  FEMALE: [
    -196.2143303900512, 18.996980048246403, -0.19628216999217346,
    0.0011643201753285188, -3.1431479006111683e-6,
  ],
};

function poly(bw: number, c: number[]) {
  return c.reduce((s, ci, i) => s + ci * Math.pow(bw, i), 0);
}

const absCoef = function (lifter: Lifter, meet: Meet) {
  let bodyWeight = lifter.bodyWeight;

  if (isLbsMeet(meet)) {
    bodyWeight = toKg(bodyWeight);
  }

  const gender = lifter.gender;

  if (!bodyWeight || !gender) {
    return 0;
  }

  if (gender === "MX") {
    return 0;
  }

  const p = params[gender];

  return 500.0 / poly(bodyWeight, p);
};

export const getAbsPoints: GetScore = ({
  lifter,
  division,
  meet,
  forecasted,
}) => {
  let total = getTotal({ lifter, division, meet, forecasted });
  if (isLbsMeet(meet)) {
    total = toKg(total);
  }

  return total * absCoef(lifter, meet);
};

export const getAbsAndAgePoints: GetScore = ({
  lifter,
  division,
  meet,
  forecasted,
}) => {
  return (
    getAbsPoints({ lifter, division, meet, forecasted }) * ageCoef(lifter, meet)
  );
};
